module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('breadcrumb', {
    attrs: {
      "crumbs": _vm.crumbs
    }
  }), _vm._v(" "), _c('flash-message'), _vm._v(" "), _c('div', {
    staticClass: "ls-clearfix"
  }), _vm._v(" "), _c('label', {
    staticClass: "ls-float-right",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('i', {
    staticClass: "fa fa-search seach",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    staticClass: "ls-sm-margin-right",
    staticStyle: {
      "padding-left": "40px"
    },
    attrs: {
      "type": "search",
      "placeholder": "Nome do adquirente"
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "ls-title-4 ls-sm-margin-left"
  }, [_vm._v(_vm._s(_vm.$t('settings.attributes.select_acquirer')))]), _vm._v(" "), _c('div', {
    staticClass: "acquirers"
  }, _vm._l((_vm.processorList), function(processor, index) {
    return _c('div', {
      staticClass: "col-md-2",
      on: {
        "click": function($event) {
          _vm.showProcessor(processor)
        }
      }
    }, [_c('div', {
      staticClass: "box-payment-method ls-box ls-board-box shadow-box ls-cursor-pointer col-md-12"
    }, [_c('img', {
      staticClass: "ls-float-left ls-md-margin-bottom ls-md-space image-size",
      attrs: {
        "src": processor.logo
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "ls-txt-center col-md-12"
    }, [_vm._v(_vm._s(processor.description))])])])
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52ca3841"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/settings/IndexPaymentSettings.vue
// module id = 780
// module chunks = 1